import UriTemplate from '@hyperjump/uri-template';
import { MOCK_BASE_URL } from '../../../utils/requests/community_requests';

export const PERSONAL = 'personal';
export const PUBLIC = 'public';
export const FOLLOWERS = 'followers';
export const TIMELINE = 'timeline';

export const FEED_LABEL_MAP = { // STILL FIGURING OUT LANGUAGE HERE FOR DIFFERENT FOLLOWERS
  [PERSONAL]: 'My posts',
  [PUBLIC]: 'Feed',
  [FOLLOWERS]: 'Followers',
  [TIMELINE]: 'Timeline'
};

export const getParsedHref = (href, hrefSchema, templateRequired) => {
  const template = href.replace('https://alpha.alltrails.com/community', MOCK_BASE_URL);
  const parameters = Object.fromEntries(
    Object.entries(hrefSchema)
      .filter(([k, v]) => templateRequired.includes(k) && v.default)
      .map(([k, v]) => [k, v.default])
  );

  return UriTemplate.expand(template, parameters);
};

export const formatHrefs = feedOption => {
  const { name, links } = feedOption;
  const label = FEED_LABEL_MAP[name];

  return Object.fromEntries(
    links.map(({ rel, href, hrefSchema, templateRequired }) => {
      return [rel, { label, name, href: getParsedHref(href, hrefSchema, templateRequired) }];
    })
  );
};

export const formatFeedOption = feedOption => {
  return {
    label: FEED_LABEL_MAP[feedOption.name],
    name: feedOption.name,
    links: formatHrefs(feedOption)
  };
};

export const formatFeedOptions = feedOptions => {
  return feedOptions.map(formatFeedOption);
};
